import React from 'react';
import { Card } from './ui/card';
import { TrendingUp, MapPin, Star } from 'lucide-react';
import { useApp } from '../context/PetParksContext';

interface StatsCardProps {
  totalParks: number;
  avgRating: number;
  nearbyCount: number;
}

export const StatsCard: React.FC<StatsCardProps> = ({
  totalParks,
  avgRating,
  nearbyCount,
}) => {
  const { t } = useApp();
  return (
    <Card className="p-4">
      <div className="grid grid-cols-3 gap-4">
        <div className="text-center">
          <div className="mb-1 flex items-center justify-center">
            <MapPin className="h-5 w-5 text-primary" />
          </div>
          <p className="text-2xl font-bold text-foreground">{totalParks}</p>
          <p className="text-xs text-muted-foreground">{t('totalParks')}</p>
        </div>
        <div className="border-l border-r text-center">
          <div className="mb-1 flex items-center justify-center">
            <Star className="h-5 w-5 text-yellow-500" />
          </div>
          <p className="text-2xl font-bold text-foreground">
            {avgRating.toFixed(1)}
          </p>
          <p className="text-xs text-muted-foreground">{t('avgRating')}</p>
        </div>
        <div className="text-center">
          <div className="mb-1 flex items-center justify-center">
            <TrendingUp className="h-5 w-5 text-green-500" />
          </div>
          <p className="text-2xl font-bold text-foreground">{nearbyCount}</p>
          <p className="text-xs text-muted-foreground">{t('nearby')}</p>
        </div>
      </div>
    </Card>
  );
};
